var map = {
	"./abw.svg": "4b9d",
	"./afg.svg": "543f",
	"./ago.svg": "e9bf",
	"./aia.svg": "12c5",
	"./ala.svg": "d82b",
	"./alb.svg": "9da6",
	"./and.svg": "5441",
	"./are.svg": "572a",
	"./arg.svg": "ee5b",
	"./arm.svg": "7f04",
	"./asm.svg": "2b4d",
	"./ata.svg": "d000",
	"./atf.svg": "aa88",
	"./atg.svg": "4835",
	"./aus.svg": "b8ef",
	"./aut.svg": "60e9",
	"./aze.svg": "b0b1",
	"./bdi.svg": "40dd",
	"./bel.svg": "be26",
	"./ben.svg": "97ae",
	"./bes.svg": "8662",
	"./bfa.svg": "5f05",
	"./bgd.svg": "3366",
	"./bgr.svg": "ecf1",
	"./bhr.svg": "2c9f",
	"./bhs.svg": "00bb",
	"./bih.svg": "1877",
	"./blm.svg": "573f",
	"./blr.svg": "8f77",
	"./blz.svg": "6eed",
	"./bmu.svg": "e81e",
	"./bol.svg": "41a6",
	"./bra.svg": "9f2b",
	"./brb.svg": "a3f0",
	"./brn.svg": "2caa",
	"./btn.svg": "592e",
	"./bvt.svg": "237b",
	"./bwa.svg": "09cd",
	"./can.svg": "1b4c",
	"./cck.svg": "3224",
	"./che.svg": "6971",
	"./chl.svg": "12cd",
	"./chn.svg": "7bae",
	"./civ.svg": "d3d2",
	"./cmr.svg": "244e",
	"./cod.svg": "4312",
	"./cog.svg": "3832",
	"./cok.svg": "dbe1",
	"./col.svg": "0000",
	"./com.svg": "1135",
	"./cpv.svg": "d461",
	"./cri.svg": "07bb",
	"./cta.svg": "492d",
	"./cub.svg": "0d70",
	"./cuw.svg": "d83e",
	"./cxr.svg": "aacb",
	"./cym.svg": "f5f5",
	"./cyp.svg": "2a2c",
	"./cze.svg": "bc40",
	"./deu.svg": "0f89",
	"./dji.svg": "4da9",
	"./dma.svg": "6268",
	"./dnk.svg": "fe9d",
	"./dom.svg": "41fa",
	"./dza.svg": "42ed",
	"./ecu.svg": "d954",
	"./egy.svg": "3805",
	"./eqg.svg": "e9c2",
	"./eri.svg": "7ee7",
	"./esh.svg": "baac",
	"./esp.svg": "6d27",
	"./est.svg": "f75c",
	"./eth.svg": "867d",
	"./fin.svg": "408d",
	"./fji.svg": "8da1",
	"./flk.svg": "4c2e",
	"./fra.svg": "267b",
	"./fro.svg": "e978",
	"./fsm.svg": "6191",
	"./gab.svg": "b37c",
	"./gbr.svg": "06e9",
	"./geo.svg": "8479",
	"./ggy.svg": "cc40",
	"./gha.svg": "6e8d",
	"./gib.svg": "0215",
	"./gin.svg": "1dac",
	"./glp.svg": "99f4",
	"./gmb.svg": "d08e",
	"./gnb.svg": "092e",
	"./grc.svg": "0b6e",
	"./grd.svg": "4022",
	"./grl.svg": "28e9",
	"./gtm.svg": "8c60",
	"./guf.svg": "564f",
	"./gum.svg": "f71f",
	"./guy.svg": "2d3b",
	"./hkg.svg": "ecc9",
	"./hmd.svg": "b73c",
	"./hnd.svg": "75c2",
	"./hrv.svg": "1ee8",
	"./hti.svg": "d092",
	"./hun.svg": "7673",
	"./idn.svg": "e0fc",
	"./imn.svg": "5659",
	"./ind.svg": "3afd",
	"./iot.svg": "9122",
	"./irl.svg": "8e2c",
	"./irn.svg": "ce2e",
	"./irq.svg": "5d3d",
	"./isl.svg": "548a",
	"./isr.svg": "05b5",
	"./ita.svg": "72d1",
	"./jam.svg": "17cd",
	"./jey.svg": "99c1",
	"./jor.svg": "cff1",
	"./jpn.svg": "e627",
	"./kaz.svg": "de6d",
	"./ken.svg": "3bac",
	"./kgz.svg": "a093",
	"./khm.svg": "09ee",
	"./kir.svg": "71b5",
	"./kna.svg": "5e84",
	"./kor.svg": "0b86",
	"./kwt.svg": "ddc1",
	"./lao.svg": "15b4",
	"./lbn.svg": "2a53",
	"./lbr.svg": "60ca",
	"./lby.svg": "6cb7",
	"./lca.svg": "24c2",
	"./lie.svg": "7fc2",
	"./lka.svg": "0514",
	"./lso.svg": "98e1",
	"./ltu.svg": "e843",
	"./lux.svg": "f020",
	"./lva.svg": "2940",
	"./mac.svg": "9b4a",
	"./maf.svg": "a760",
	"./mar.svg": "25b5",
	"./mco.svg": "ff7a",
	"./mda.svg": "69c7",
	"./mdg.svg": "2b35",
	"./mdv.svg": "ad34",
	"./mex.svg": "007b",
	"./mhl.svg": "7df6",
	"./mkd.svg": "c8cc",
	"./mli.svg": "a81f",
	"./mlt.svg": "727c",
	"./mmr.svg": "70a9",
	"./mne.svg": "b140",
	"./mng.svg": "efef",
	"./mnp.svg": "0749",
	"./moz.svg": "42e2",
	"./mrt.svg": "26d6",
	"./msr.svg": "9e4f",
	"./mtq.svg": "f12d",
	"./mus.svg": "b6ef",
	"./mwi.svg": "a434",
	"./mys.svg": "1143",
	"./myt.svg": "3cf1",
	"./nam.svg": "eee8",
	"./ner.svg": "5abc",
	"./nfk.svg": "2c8c",
	"./nga.svg": "56f9",
	"./nic.svg": "e198",
	"./niu.svg": "13d0",
	"./nld.svg": "ef86",
	"./nor.svg": "4a85",
	"./npl.svg": "8f9c",
	"./nru.svg": "f616",
	"./nzl.svg": "c469",
	"./omn.svg": "dea2",
	"./pak.svg": "2012",
	"./pan.svg": "7208",
	"./pcn.svg": "4973",
	"./per.svg": "f62a",
	"./phl.svg": "e53b",
	"./plw.svg": "2a81",
	"./png.svg": "4da6",
	"./pol.svg": "89cd",
	"./pri.svg": "d5cc",
	"./prk.svg": "feda",
	"./prt.svg": "4594",
	"./pry.svg": "205a",
	"./pse.svg": "e87c",
	"./pyf.svg": "9eb0",
	"./qat.svg": "92c2",
	"./reu.svg": "3eb7",
	"./rou.svg": "6b8d",
	"./rus.svg": "2d11",
	"./rwa.svg": "9e8a",
	"./sau.svg": "e2a6",
	"./sdn.svg": "a387",
	"./sen.svg": "ae72",
	"./sgs.svg": "ab3d",
	"./shn.svg": "fc47",
	"./sin.svg": "e9a8",
	"./sjm.svg": "c5c1",
	"./slb.svg": "34bb",
	"./sle.svg": "9dfb",
	"./slv.svg": "855e",
	"./smr.svg": "e35d",
	"./som.svg": "2d60",
	"./spm.svg": "b1ee",
	"./srb.svg": "728f",
	"./ssd.svg": "80bf",
	"./stp.svg": "1635",
	"./sur.svg": "962a",
	"./svk.svg": "b6b7",
	"./svn.svg": "3513",
	"./swe.svg": "5846",
	"./swz.svg": "ee80",
	"./sxm.svg": "14b9",
	"./syc.svg": "43b7",
	"./syr.svg": "eac9",
	"./tca.svg": "c8d9",
	"./tcd.svg": "4e81",
	"./tgo.svg": "58c9",
	"./tha.svg": "b85c5",
	"./tjk.svg": "cd0e",
	"./tkl.svg": "2db8",
	"./tkm.svg": "3a85",
	"./tls.svg": "c894",
	"./ton.svg": "ec046",
	"./tri.svg": "e8ca",
	"./tun.svg": "73f7",
	"./tur.svg": "0e17",
	"./tuv.svg": "4ca4",
	"./twn.svg": "9f4a",
	"./tza.svg": "6ffd",
	"./uga.svg": "805f",
	"./ukr.svg": "3eb0",
	"./umi.svg": "95fe",
	"./ury.svg": "90d3",
	"./usa.svg": "d7ac",
	"./uzb.svg": "c360",
	"./vat.svg": "373f",
	"./vct.svg": "32d7",
	"./ven.svg": "0528",
	"./vgb.svg": "1961",
	"./vir.svg": "65ff",
	"./vnm.svg": "653f",
	"./vut.svg": "253b",
	"./wlf.svg": "9ab7",
	"./wsm.svg": "c54e",
	"./yem.svg": "4952",
	"./zaf.svg": "ccba",
	"./zim.svg": "7363",
	"./zmb.svg": "942b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9a5";